// Centralized styling configuration for mobile site navigation menu
export const getMobileSiteNavMenuStyles = () => {
  const styles = {
    sidebar: {
      rootStyles: {
        color: '#adadad',
        width: '250px',
        height: '100%',
        borderRight: '1px solid #000',
        transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        zIndex: 2147483647,
        position: 'fixed',
        top: 0,
        left: 0,
        transform: 'translateX(-100%)',
        '&.ps-toggled': {
          boxShadow: '5px 5px 5px rgba(0, 0, 0, 0.5)',
          transform: 'translateX(0)'
        }
      },
      backgroundColor: '#1d1d1d'
    },

    menu: {
      style: {
        borderTop: '1px solid hsla(0,0%,68%,.2)',
        paddingBottom: '10px',
        paddingTop: '10px'
      },
      menuItemStyles: {
        subMenuContent: {
          backgroundColor: '#2b2b2b'
        },
        button: {
          backgroundColor: '#1d1d1d',
          color: '#adadad',
          fontSize: '15px',
          padding: '4px 35px 4px 20px',
          height: '40px',
          '&:hover': {
            backgroundColor: '#1d1d1d',
            color: '#adadad'
          },
          '&:active': {
            backgroundColor: '#1d1d1d',
            color: '#adadad'
          },
          '&.ps-active': {
            backgroundColor: '#1d1d1d',
            color: '#adadad'
          },
          '&.ps-open': {
            backgroundColor: '#1d1d1d',
            color: '#adadad'
          },
          '&:focus': {
            backgroundColor: '#1d1d1d',
            color: '#adadad',
            outline: 'none'
          }
        },
        label: {
          color: '#adadad',
          fontSize: '15px'
        },
        icon: {
          color: '#adadad',
          fontSize: '14px',
          height: '30px',
          lineHeight: '30px',
          minWidth: '30px',
          width: '30px',
          marginRight: '10px'
        },
        SubMenuExpandIcon: {
          color: '#adadad',
          fontSize: '14px',
          height: '30px',
          lineHeight: '30px',
          minWidth: '30px',
          width: '30px'
        }
      }
    },

    link: {
      style: {
        color: '#adadad'
      }
    },

    backdrop: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 2147483646
    }
  };

  return styles as any;
};
